import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getAllAssignmentsPortal = async (filters = {}) => {
  const res = await axiosInstance.get("/teacher-subject-portal/all", { params: filters });
  return res.data;
};

export const getMySubjects = async () => {
  const res = await axiosInstance.get("/teacher-subject-portal/my-subjects");
  return res.data;
};

export const getSectionSubjectsPortal = async (sectionId) => {
  const res = await axiosInstance.get(`/teacher-subject-portal/section/${sectionId}`);
  return res.data;
};